import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/app/(staitc-page)/student-discount/components/MightLike.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/app/(staitc-page)/student-discount/components/StudentBeansWidget.tsx");
